/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../graphql/__generated__/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OfferingProfile_DeleteParticipationSetMutationVariables = Types.Exact<{
  input: Types.DeleteParticipationSetInput;
}>;

export type OfferingProfile_DeleteParticipationSetMutation = {
  __typename?: 'Mutation';
  deleteParticipationSet?: {
    __typename?: 'DeleteParticipationSetPayload';
    participationSet?: { __typename?: 'ParticipationSet'; offeringId?: string | null } | null;
  } | null;
};

export const OfferingProfile_DeleteParticipationSetDocument = gql`
  mutation OfferingProfile_DeleteParticipationSet($input: DeleteParticipationSetInput!) {
    deleteParticipationSet(input: $input) {
      participationSet {
        offeringId
      }
    }
  }
`;
export type OfferingProfile_DeleteParticipationSetMutationFn = Apollo.MutationFunction<
  OfferingProfile_DeleteParticipationSetMutation,
  OfferingProfile_DeleteParticipationSetMutationVariables
>;

/**
 * __useOfferingProfile_DeleteParticipationSetMutation__
 *
 * To run a mutation, you first call `useOfferingProfile_DeleteParticipationSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferingProfile_DeleteParticipationSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offeringProfileDeleteParticipationSetMutation, { data, loading, error }] = useOfferingProfile_DeleteParticipationSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferingProfile_DeleteParticipationSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OfferingProfile_DeleteParticipationSetMutation,
    OfferingProfile_DeleteParticipationSetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OfferingProfile_DeleteParticipationSetMutation,
    OfferingProfile_DeleteParticipationSetMutationVariables
  >(OfferingProfile_DeleteParticipationSetDocument, options);
}
export type OfferingProfile_DeleteParticipationSetMutationHookResult = ReturnType<
  typeof useOfferingProfile_DeleteParticipationSetMutation
>;
export type OfferingProfile_DeleteParticipationSetMutationResult =
  Apollo.MutationResult<OfferingProfile_DeleteParticipationSetMutation>;
export type OfferingProfile_DeleteParticipationSetMutationOptions = Apollo.BaseMutationOptions<
  OfferingProfile_DeleteParticipationSetMutation,
  OfferingProfile_DeleteParticipationSetMutationVariables
>;
